import { render, staticRenderFns } from "./PremiumReport1024.vue?vue&type=template&id=0bbf8385&scoped=true"
import script from "./PremiumReport1024.vue?vue&type=script&lang=js"
export * from "./PremiumReport1024.vue?vue&type=script&lang=js"
import style0 from "./PremiumReport1024.vue?vue&type=style&index=0&id=0bbf8385&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf8385",
  null
  
)

export default component.exports